/**
 * LICITARS 3.0 - Premium Navy/Silver Layout
 * Role-based navigation with glassmorphism effects
 */

import React from "react";
import { Outlet } from "react-router-dom";
import AppSidebarV3 from "./AppSidebarV3";
import AppHeaderV3 from "./AppHeaderV3";
import { useAuth } from "@/contexts/AuthContext";

const AppLayoutV3 = () => {
  const { user } = useAuth();

  return (
    <div className="h-screen flex w-full overflow-hidden bg-navy-800">
      <AppSidebarV3 userRole={user?.role} />
      {/* Main content area */}
      <div className="flex flex-col flex-1 min-h-0">
        <AppHeaderV3 />
        {/* Content with navy theme */}
        <main className="flex-1 p-6 overflow-auto min-h-0 bg-navy-800">
          <Outlet />
        </main>
        {/* Footer with navy theme */}
        <footer className="flex-shrink-0 p-2 border-t border-navy-500 text-center text-xs text-muted-foreground">
          <p>
            LicitarsAI © {new Date().getFullYear()} - v1.0.0 | Plataforma de IA para Gestão de Licitações
          </p>
        </footer>
      </div>
    </div>
  );
};

export default AppLayoutV3;
